/**
 * @generated SignedSource<<3aed56f5a6be61dbfd71eb1abd2eff1f>>
 * @relayHash 713dcc94c33b95effc35a51e617fe45e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ebcb5cbbf64a661859bc6943de5038a2eb40f579962479da955430ebffa83aba

import type { ConcreteRequest } from 'relay-runtime';
export type ContentVersionHistoryFilter = {
  contentType: string;
};
export type useVersionHistoryContentVersionHistoryQuery$variables = {
  after?: string | null;
  contentId: string;
  filter: ContentVersionHistoryFilter;
  includeCollaborators?: boolean | null;
};
export type useVersionHistoryContentVersionHistoryQuery$data = {
  readonly contentVersionHistory: {
    readonly nodes: ReadonlyArray<{
      readonly author: {
        readonly displayName: string | null;
        readonly id: string | null;
        readonly isActive: boolean | null;
      } | null;
      readonly collaborators?: ReadonlyArray<{
        readonly agent: {
          readonly accountId: string;
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
        } | null;
        readonly person: {
          readonly accountId?: string | null;
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
        };
      } | null>;
      readonly contentId: string;
      readonly contentProperties: {
        readonly latest: {
          readonly externalVersionId: string | null;
          readonly versionContainsAIContent: boolean | null;
        } | null;
      } | null;
      readonly number: number;
      readonly updatedTime: string;
    }>;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: string | null;
    };
  } | null;
};
export type useVersionHistoryContentVersionHistoryQuery = {
  response: useVersionHistoryContentVersionHistoryQuery$data;
  variables: useVersionHistoryContentVersionHistoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeCollaborators"
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v6 = {
  "concreteType": "AtlassianUser",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "isActive"
    },
    (v5/*: any*/)
  ]
},
v7 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v8 = [
  (v7/*: any*/)
],
v9 = {
  "kind": "InlineFragment",
  "selections": (v8/*: any*/),
  "type": "KnownUser"
},
v10 = {
  "kind": "InlineFragment",
  "selections": (v8/*: any*/),
  "type": "UnknownUser"
},
v11 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v12 = {
  "concreteType": "ConfluenceAgent",
  "kind": "LinkedField",
  "name": "agent",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v5/*: any*/),
    (v11/*: any*/)
  ]
},
v13 = {
  "kind": "ScalarField",
  "name": "contentId"
},
v14 = {
  "kind": "ScalarField",
  "name": "number"
},
v15 = {
  "kind": "ScalarField",
  "name": "updatedTime"
},
v16 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "externalVersionId"
        },
        {
          "kind": "ScalarField",
          "name": "versionContainsAIContent"
        }
      ]
    }
  ]
},
v17 = {
  "concreteType": "ContentVersionHistoryPageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    },
    {
      "kind": "ScalarField",
      "name": "hasPreviousPage"
    },
    {
      "kind": "ScalarField",
      "name": "startCursor"
    },
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useVersionHistoryContentVersionHistoryQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "ContentVersionHistoryConnection",
        "kind": "LinkedField",
        "name": "contentVersionHistory",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentVersion",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "condition": "includeCollaborators",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "ConfluenceCollaborator",
                    "kind": "LinkedField",
                    "name": "collaborators",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "person",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v5/*: any*/),
                          (v11/*: any*/)
                        ]
                      },
                      (v12/*: any*/)
                    ]
                  }
                ]
              },
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/)
            ]
          },
          (v17/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "useVersionHistoryContentVersionHistoryQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "ContentVersionHistoryConnection",
        "kind": "LinkedField",
        "name": "contentVersionHistory",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentVersion",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "condition": "includeCollaborators",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "ConfluenceCollaborator",
                    "kind": "LinkedField",
                    "name": "collaborators",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "person",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          },
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v5/*: any*/),
                          (v11/*: any*/)
                        ]
                      },
                      (v12/*: any*/)
                    ]
                  }
                ]
              },
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/)
            ]
          },
          (v17/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "713dcc94c33b95effc35a51e617fe45e",
    "id": "ebcb5cbbf64a661859bc6943de5038a2eb40f579962479da955430ebffa83aba",
    "metadata": {},
    "name": "useVersionHistoryContentVersionHistoryQuery",
    "operationKind": "query",
    "text": "query useVersionHistoryContentVersionHistoryQuery($contentId:ID!,$filter:ContentVersionHistoryFilter!,$after:String,$includeCollaborators:Boolean=false){contentVersionHistory(id:$contentId,after:$after,first:30,filter:$filter){nodes{author{id,isActive,displayName},collaborators@include(if:$includeCollaborators){person{__typename,...on KnownUser{accountId},...on UnknownUser{accountId},displayName,profilePicture{path}},agent{accountId,displayName,profilePicture{path}}},contentId,number,updatedTime,contentProperties{latest{externalVersionId,versionContainsAIContent}}},pageInfo{hasNextPage,hasPreviousPage,startCursor,endCursor}}}"
  }
};
})();

(node as any).hash = "4539e00c2da76cd669b427c8bae39d16";

export default node;
